var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.379,
    y1: -1.238,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "ivory"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#f9f9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce93d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.586,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "ivory"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce93d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-palace",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M61.667,24,56.131,13,50.6,24Zm-40.6,0L15.536,13,10,24Z",
    transform: "translate(4.166 6.75)",
    fill: "#8e24aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M24.762,15H46.905V31.5H24.762ZM50.6,22.333H61.667V31.5H50.6Zm-40.6,0H21.072V31.5H10Z",
    transform: "translate(4.166 8.448)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M63.947,18V29H16.053V18H5V63.832H75V18Z",
    transform: "translate(0 11.168)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M56.579,75H23.421C23.421,58.421,40,52.895,40,52.895S56.579,58.421,56.579,75ZM75,28.947,69.474,17.895,63.947,28.947ZM51.053,23.421,40,5,28.947,23.421Zm-35,5.526L10.526,17.895,5,28.947Z",
    transform: "translate(-5 -5)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(16.167 29.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M58.666,38.166l-2.75-1.833-2.75,1.833v9.166h5.5Zm-42.166,0-2.75-1.833L11,38.166v9.166h5.5Zm23.833-16.5L34.833,18l-5.5,3.667V29h11Z",
    transform: "translate(-11 -18)",
    fill: "url(#linear-gradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.336b8e7ad4cd2e57b6650a2fe4966b1e.svg";
export { ForwardRef as ReactComponent };